import { Controller } from "@hotwired/stimulus"

const SUBDIVISION_FIELD_NAME = "practitioner_license[issuing_state]"
const NAMED_COUNTRIES = ["US", "CA"]

// US and CA keep their dedicated state / province selects in the DOM so
// switching between them stays instant. Any other country loads its region
// field from the server: a subdivision select when ISO has them, otherwise
// a free-text issuing authority.
export default class extends Controller {
  static targets = ["countryInput", "subdivisionInput", "otherRegion"]
  static values = { issuingRegionUrl: String }

  syncSubdivisionFields(event) {
    // Every app-select in the form bubbles this event, including license type.
    if (event.target !== this.countryInputTarget) return

    const country = this.countryInputTarget.value
    this.activateNamedSubdivision(country)

    if (NAMED_COUNTRIES.includes(country)) {
      this.deactivateOtherRegion()
      return
    }

    this.loadOtherRegion(country)
  }

  activateNamedSubdivision(country) {
    this.subdivisionInputTargets.forEach((input) => {
      const active = input.dataset.country === country
      const container = input.closest(".app-select-container")
      if (container) container.classList.toggle("d-none", !active)
      input.name = active ? SUBDIVISION_FIELD_NAME : ""
    })
  }

  deactivateOtherRegion() {
    this.regionAbortController?.abort()
    if (!this.hasOtherRegionTarget) return

    this.otherRegionTarget.classList.add("d-none")
    this.otherRegionTarget.querySelectorAll("[name]").forEach((input) => {
      input.name = ""
    })
  }

  async loadOtherRegion(country) {
    if (!this.hasOtherRegionTarget || !this.issuingRegionUrlValue) return

    this.regionAbortController?.abort()
    this.regionAbortController = new AbortController()

    const url = new URL(this.issuingRegionUrlValue, window.location.origin)
    url.searchParams.set("country", country)

    let response
    try {
      response = await fetch(url, {
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
        signal: this.regionAbortController.signal
      })
    } catch (error) {
      if (error.name === "AbortError") return
      return
    }

    if (!response.ok) return
    if (this.countryInputTarget.value !== country) return

    this.otherRegionTarget.innerHTML = await response.text()
    this.otherRegionTarget.classList.remove("d-none")
  }
}
